import UserDetail from '../layout/userDetail';

export const UserDetails = UserDetail;
